import * as React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import Typed from 'react-typed';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Layout from '../components/Layout/Layout';
import HomeHero from '../components/Hero';
import NftTimeline from '../components/NftTimeline';
import Counts from '../components/Counts';
import Carousel from '../components/Carousel/Carousel';
import AccessoryList from '../components/AccessoryList';
import Faq from '../components/Faq';

import { RootState } from "../store";

import { useDispatch, useSelector } from "react-redux";
import PricingTimeline from '../components/PricingTimeline';
import About from '../components/About/About';

export default function Index() {
  const state = useSelector((state: RootState) => state.nft);

  return (
    <Layout title="HayApe NFT">
      <HomeHero />
      <Container maxWidth="lg">

        <Typography variant="overline" align="center" sx={{ mt: 2 }} component="div">
          Ready to Join the Hayape club?
        </Typography>

        <Counts />
      </Container>

      <Carousel />

      <Container maxWidth="lg" sx={{ mt: 2, mb: 10 }}>
        <Typography align="center" variant="h5">
          HayApe is created for fun, in reference to the "QYARTU" culture and lifestyle of 90's.
        </Typography>

        <PricingTimeline />

      </Container>
      <AccessoryList />

      <Faq />

      <About />
    </Layout>
  );
}